import { render, staticRenderFns } from "./ReimbursementInsight.vue?vue&type=template&id=220c74be&"
import script from "./ReimbursementInsight.vue?vue&type=script&lang=js&"
export * from "./ReimbursementInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports